import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refChaosDownloadPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'カオスマップ スマホアプリ モバイルアプリ グロース アプリ開発'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/mobile-app-technology-chaos-map-2025/done/'}
          title="モバイルアプリテクノロジーカオスマップ2025 | 資料ダウンロード | Aitria（アイトリア）"
          description="モバイルアプリのグロースサイクルを軸とした、国内外の主要な92のソリューションを網羅的に紹介した資料です。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
